module.exports = __webpack_public_path__ + "img/information-selected.9918db72.png";